<template>
  <v-container class="riiqosxn riiqosxn-four">
    <v-row>
      <v-col cols="12 text-center">
        <h1 class="title-lg">Storage for All</h1>
        <div class="col-content">
          <h5>Files in the Cloud</h5>
          <p>Share your important business documents with only who should see them in your company. Edit your Google Docs and Sheets within the system. Assign files to leads or customers, and access them easily from the customer page. Save receipts, contracts, or anything you like.</p>
        </div>
        <router-link to="contact" class="btn btn-getstarted">Get Started</router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SxnFour',

  data: () => ({
    
  }),
};
</script>
